import { ApiService } from "../../../../../core";
import { FormSignupController, ProfileUpdateResponse, SignupResponse } from "../../core";

export class FormSignupControllerImpl implements FormSignupController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<string> {
        try {
            const response: string = await this.api.get(`/signup`);
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async signup(formData: FormData): Promise<string | null> {
        try {
            const response: SignupResponse = await this.api.post(`/signup`, formData);

            return response.response;
        } catch (error) {
            if (error.response && error.response.data) {
                return error.response.data;
            } else {
                throw new Error(error.response.data);
            }
        }
    }

    async signupCodeValidate(formData: FormData): Promise<SignupResponse> {
        try {
            const response: SignupResponse = await this.api.post(`/signup-code-validation`, formData);

            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async profileUpdateCodeValidate(formData: FormData): Promise<ProfileUpdateResponse> {
        try {
            const response: ProfileUpdateResponse = await this.api.post(`/profile-code-validation`, formData);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                // eslint-disable-next-line no-throw-literal
                throw ("401");
            } else {
                throw new Error(error.response.data);
            }
        }
    }
}